import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { Kot, KotCreate, KotFilter } from '../data/kot';

export function createKotService(client: AxiosInstance) {
  return createCrudService<Kot, KotCreate, KotFilter>(
    client,
    '/restaurant/Kot',
    'id',
  );
}

export type KotService = CrudService<Kot, KotCreate, KotFilter>;
